// extracted by mini-css-extract-plugin
module.exports = {"close":"modal_confirmation_header-module__close--3Yp3J","icon":"modal_confirmation_header-module__icon--39ee0","title":"modal_confirmation_header-module__title--4tLLz"};